<template>
  <header class="bloc-header">
    <div class="bloc-header__wraper">
      <router-link to="/">
        <img svg-inline class="bloc-header__logo" src="@/assets/images/icons/logo.svg" />
      </router-link>
    </div>
  </header>
</template>

<script>
import store from '@/store/store';

export default {
  name: 'Header',
  props: {
  },
  methods: {
  },
}
</script>

<style lang="scss" scoped>
  .bloc-header {
    width: 100vw;
    height: rem(80);
    top: 0;
    position: sticky;
    z-index: 10;

    &__wraper {
      width: 100vw;
      height: rem(80);
      transition: height 0.3s $quad-ease-out;
      background: $th-cherry;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    a {
      height: 100%;
      display: flex;
      justify-content: center;
      align-items: center;
    }

    &__logo {
      height: rem(50);
      width: auto;
      position: relative;
      object-fit: contain;
      transform: translateY(-4px);
      transition: transform 0.3s $quad-ease-out;

      @include media($from: small) {
        height: rem(50);
      }
    }
  }
</style>

